module.exports = "/assets/7d24830fc104994bef955a41feaf216e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CJ.png
// module id = 1267
// module chunks = 0